let r=(r=21)=>{let t="",e=r;for(;e--;)t+="useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"[64*Math.random()|0];return t};export{r as n};
//# sourceMappingURL=index-bd43cdd3.js.map
